import { useEffect, useState } from "react";
import LandingTop from "../components/LandingTop";
import localeEn from "../locales/landing.en.json";
import localeFi from "../locales/landing.fi.json";
import localeSe from "../locales/landing.se.json";
import localeNo from "../locales/landing.no.json";
import useI18n from "../hooks/useI18n";
import useUserAccount from "../hooks/useUserAccount";
import Landing2nd from "../components/Landing2nd";
import Landing3rd from "../components/Landing3rd";
import Landing4th from "../components/Landing4th";
import Landing5th from "../components/Landing5th";
import Landing6th from "../components/Landing6th";
import LandingFooter from "../components/LandingFooter";
import CountrySelectionModal from "../components/CountrySelectionModal";
import ContactFormModal from "../components/ContactFormModal";
import { useLocation, useNavigate } from "react-router-dom";
import { CUSTOMERTYPE } from "../contexts/AuthContext";

const locales = {
    en: localeEn,
    fi: localeFi,
    se: localeSe,
    no: localeNo
}

const Landing = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { getLocale, getCountry, systemCountries } = useI18n();
    const { personalAuthLink, companyAuthLink } = useUserAccount();
    const [alert, setAlert] = useState(null);
    const [modalCustomerType, setModalCustomerType] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
    const locale = locales[getLocale() ?? 'en'];
    const isGlobal = getCountry() === 'global';

    const handleContact = () => {
        if (isGlobal) {
            setShowContactModal(true);
        } else {
            const contactUrl = systemCountries.find(c => c.locale === getCountry())?.contactUrl;
            if (contactUrl) window.open(contactUrl, '_blank', 'noreferrer');
        }
    };

    const handleSignIn = (customerType) => {
        if (isGlobal) {
            setModalCustomerType(customerType);
        } else {
            const authLink = customerType === CUSTOMERTYPE.COMPANY ? companyAuthLink : personalAuthLink;
            if (typeof authLink === 'string') {
                window.location.href = authLink;
            } else {
                navigate(authLink);
            }
        }
    };

    useEffect(() => {
        // make sure that chat is not visible in the login page
        removeLivechat();

        // check if alert is passed in location props
        if (location?.state?.alert) {
            setAlert({ message: location.state.alert.message, type: location.state.alert.type ?? 'light' });
        }
    }, []);

    /**
     * Remove livechat script and the chat widget container,
     * because chat should not be usable in login page.
     */
    const removeLivechat = () => {
        // remove chat script
        const scripts = document.getElementsByTagName('script');
        const url = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';

        if (typeof scripts[0]?.src === 'string' && scripts[0].src.includes(url)) {
            scripts[0].remove();
        }

        // remove the whole chat widget container
        if (document.getElementById('chat-widget-container')) {
            document.getElementById('chat-widget-container').remove();
        }
    }

    return (
        <div id='landing-page'>
            {isGlobal && (
                <>
                    <CountrySelectionModal
                        show={!!modalCustomerType}
                        onHide={() => setModalCustomerType(null)}
                        customerType={modalCustomerType}
                    />
                    <ContactFormModal
                        show={showContactModal}
                        onHide={() => setShowContactModal(false)}
                    />
                </>
            )}
            <LandingTop locale={locale.top} alert={alert} onSignIn={handleSignIn} />
            <Landing2nd locale={locale.second} />
            <Landing3rd locale={locale.third} />
            <Landing4th locale={locale.fourth} />
            <Landing5th locale={locale.fifth} onSignIn={handleSignIn} onContact={handleContact} />
            <Landing6th locale={locale.sixth} />
            <LandingFooter locale={locale.footer} onSignIn={handleSignIn} />
        </div>
    )
}


export default Landing;
